export default __webpack_public_path__ + "static/media/wi-showers.4843a199.svg";